import { useCallback, useEffect, useState } from "react";
import { methods } from "../../../utils/axios";
import { TestTypeService } from "../../../utils/test-type-registry";
import logo from "../../../assets/gm-logo-name.svg";
import emailIcon from "../../../assets/email_icon.png";
import testHeaderImage from "../../../assets/test-header.png";
import SortableList from "../../components/sortable-list/sortable-list";

const STEPS = {
  TERMS: 'TERMS',
  QUESTIONS: 'QUESTIONS',
  FINISHED: 'FINISHED',
};

const isAutoFillEnabled = () => {
  if (process.env.NODE_ENV !== 'production') {
    return true;
  }
  try {
    const value = localStorage.getItem('discTestEasterEgg');
    console.log('Value from localStorage for discTestEasterEgg:', value);
    return value === '35182a5354dfadb12e4c98f86d0479f6';
  } catch (error) {
    console.error('Error reading from localStorage', error);
    return false;
  }
}

const AUTOFILL_ENABLED = isAutoFillEnabled();

const DiscTest = (props) => {
  const { test, isBoundedTest } = props;
  const [arrSections, setArrSections] = useState([]);
  const [sectionActual, setSectionActual] = useState(0);
  const [redirectToCompetencyTest, setRedirectToCompetencyTest] = useState(false);
  const [pathToRedirect, setPathToRedirect] = useState('');
  const [currentStep, setCurrentStep] = useState(STEPS.TERMS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setArrSections(test.sections);
  }, [test]);

  const navegacionFormulario = (accion) => {
    let section = sectionActual;
    if ((accion === 'volver' && section === 0) || (accion === 'continuar' && section === 3)) {
      return false;
    }
    if (accion === 'volver') {
      window.scrollTo(0, 0)
      setSectionActual(section - 1)
    }
    if (accion === 'continuar' && dragAndDropHandleSubmit()) {
      window.scrollTo(0, 0);
      setSectionActual(section + 1);
    }
  }

  const selectOption = (e) => {
    // Add null checks to prevent production errors
    if (!e || !e.target || !e.target.parentElement) {
      return;
    }
    
    // Stop event propagation to prevent interference with other handlers
    e.stopPropagation();
    
    let arrSectionsEdit = arrSections;
    for (let question of arrSectionsEdit[sectionActual].questions) {
      if (question.id === e.target.parentElement.id) {
        for (let option of question.options) {
          if (option.selected) {
            delete option.selected;
          }
          if (option.id === e.target.id) {
            option.selected = true;
          }
        }
      }
    }
    setArrSections([...arrSectionsEdit]);
  }

  const cambiarSectionStepper = (section) => {
    setSectionActual(section)
  }

  const submitFormulario = () => {
    let body = { collaboratorTestID: test.collaboratorTestID };
    let answers = [];
    let arrSectionsEdit = arrSections;
    let mostrarAlerta = false;
    for (let [i, section] of arrSectionsEdit.entries()) {
      if (i !== 3) {
        const sectionKey = i.toString();
        const sectionFormData = formData[sectionKey];
        Object.keys(sectionFormData).forEach((questionID) => {
          const options = sectionFormData[questionID];
          options.forEach((currentOption, indexCurrentOption) => {
            const answer = {
              "questionOptionID": currentOption.id,
              "optionPriority": options.length - indexCurrentOption,
            };
            answers.push(answer);
          });
        });
      } else {
        for (let question of section.questions) {
          for (let option of question.options) {
            let answer = {
              "questionOptionID": option.questionOptionID,
              "optionPriority": option.selected ? 1 : 0
            }
            answers.push(answer)
          }
          if (mostrarAlerta === false) {
            let respuestaElegida = 0;
            for (let option of question.options) {
              if (option.selected) {
                respuestaElegida++;
              }
            }
            if (respuestaElegida < 1 || respuestaElegida > 1) {
              mostrarAlerta = true;
            }
          }
        }
      }
    }
    if (mostrarAlerta === true) {
      alert('Por favor, complete todas las preguntas');
    } else {
      body.answers = answers;
      setLoading(true);
      methods.post("/collaborator_tests/post_answers", body).then((res) => {
        if (res) {
          const { data } = res;
          if (data && Array.isArray(data) && data.length > 0) {
            const [result] = data;
            const { isFromBoundedTest, collaboratorTestId } = result;
            if (isBoundedTest && isFromBoundedTest) {
              setRedirectToCompetencyTest(true);
              const newPath = `/tests/start?id=${collaboratorTestId}`;
              setPathToRedirect(newPath);
              setTimeout(() => {
                window.location.href = newPath;
              }, 5000);
            }
          }
          setCurrentStep(STEPS.FINISHED);
        }
      }, (err) => {
        if (err) {
          setLoading(false);
        }
      })
    }
  }

  const nextQuestionAction = () => {
    if (currentStep === STEPS.TERMS) {
      return setCurrentStep(STEPS.QUESTIONS);
    }
    if (currentStep === STEPS.QUESTIONS) {
      return setCurrentStep(STEPS.FINISHED);
    }
  };

  const autoFill = () => {
    if (!isAutoFillEnabled()) {
      return;
    }
    const newFormData = { ...formData };

    // Fill sections 0, 1, 2 (SortableList)
    arrSections.forEach((section, sIdx) => {
      if (sIdx <= 2) {
        newFormData[sIdx] = {};
        section.questions.forEach((question) => {
          const options = question.options.map((opt) => ({
            id: opt.questionOptionID,
            text: `${opt.spanish.charAt().toUpperCase()}${opt.spanish.slice(1)}`,
          }));
          newFormData[sIdx][question.id] = options;
        });
      }
    });
    setFormData(newFormData);

    // Fill section 3 (Selectable options)
    const newSections = [...arrSections];
    if (newSections[3]) {
      newSections[3].questions.forEach((question) => {
        const randomIndex = Math.floor(Math.random() * question.options.length);
        question.options.forEach((option, oIdx) => {
          option.selected = (oIdx === randomIndex);
        });
      });
      setArrSections(newSections);
    }
  };

  const getButtonText = () => {
    if (currentStep === STEPS.TERMS) {
      return 'Aceptar y Comenzar';
    }
    if (currentStep === STEPS.QUESTIONS) {
      return 'continuar';
    }
    return '';
  };

  const [questions, setQuestions] = useState([]);
  //const [formData, setFormData] = useState({ ...DataTest });
  const [formData, setFormData] = useState({ '0': {}, '1': {}, '2': {} });

  const settingQuestionsBySection = (currentSection, sections) => {
    if (sections && sections[currentSection]) {
      const questions = sections[currentSection].questions.map((question, index) => {
        const options = question.options.map((opt) => ({
          id: opt.questionOptionID,
          text: `${opt.spanish.charAt().toUpperCase()}${opt.spanish.slice(1)}`,
        }));
        for (let i = options.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [options[i], options[j]] = [options[j], options[i]];
        }
        return {
          id: question.id,
          section: currentSection,
          options,
          title: `${index + 1}. ${question.spanish}`,
          subtitle: 'Arrastre y ordene las opciones según su prioridad, de mayor a menor relevancia.',
        };
      });
      setQuestions(questions);
    }
  }

  useEffect(() => {
    settingQuestionsBySection(sectionActual, arrSections);
  }, [sectionActual, arrSections]);

  const handleQuestionChange = useCallback((questionId, sortedItems) => {
    setFormData(prev => {
      const newData = {
        ...prev,
        [sectionActual]: {
          ...prev[sectionActual],
          [questionId]: sortedItems
        }
      };
      return newData;
    });
  }, [sectionActual]);

  const validateForm = () => {
    const missingQuestions = [];

    questions.forEach(question => {
      const questionData = formData[sectionActual][question.id];

      if (!questionData) {
        missingQuestions.push(question.title);
        return;
      }

      const hasEmptySlots = questionData.some(item => item === null);
      if (hasEmptySlots) {
        missingQuestions.push(question.title);
      }
    });

    return {
      isValid: missingQuestions.length === 0,
      missingQuestions
    };
  };

  const dragAndDropHandleSubmit = () => {
    const validation = validateForm();
    if (!validation.isValid) {
      alert('Por favor complete todas las preguntas antes de enviar.\n\n' +
        'Preguntas incompletas:\n' +
        validation.missingQuestions.map((q, i) => `${i + 1}. ${q}`).join('\n'));
      return false;
    }
    return true;
  };

  const getTitle = (title) => {
    if (title === 'Su Estilo de Trabajo') {
      return 'Autopercepción';
    }
    if (title === 'Su Estilo Natural') {
      return 'Su estilo Natural';
    }
    return title;
  };

  return (
    <div className="gm-test-container">
      <div className="test-header">
        <img src={logo} alt="growme-logo" />
      </div>

      <div className="test-main">
        <div className={`test-card ${currentStep === STEPS.TERMS ? 'test-card-terms' : ''}`}>
          <div className="test-card-header">
            {
              currentStep === STEPS.TERMS
              && <img src={testHeaderImage} alt="test-header" className="test-card-header-image" />
            }
          </div>
          <div className="test-card-body">
            {
              currentStep === STEPS.TERMS
              && <TestTerms isBoundedDiscTest={TestTypeService.getTestConfigByTest(test)?.category === 'bounded-disc'} />
            }
            {
              currentStep === STEPS.QUESTIONS
              && <div className="test-section">
                <div className="stepper">
                  {
                    arrSections.map((section, index) => {
                      return (
                        <div
                          onClick={() => { cambiarSectionStepper(index) }}
                          key={index}
                          className={index <= arrSections.indexOf(arrSections[sectionActual]) ? "step actual" : "step"}
                        >
                          <div className="gm-number-container">
                            <div className="gm-number-left" />
                            <span className="number">{index + 1}</span>
                            <div className={`gm-number-right ${arrSections[sectionActual].order > (index + 1) ? '' : 'gm-no-display-border'}`} />
                          </div>
                          <span className="title">{getTitle(section.title)}</span>
                        </div>
                      )
                    })
                  }
                </div>
                <p className="intructions-p">Instrucciones</p>
                <p className="description-p">{arrSections[sectionActual].description}</p>
                {
                  sectionActual <= 2 && questions.map((question) => {
                    return (
                      <SortableList
                        key={`${sectionActual}-${question.id}`}
                        questionId={question.id}
                        initialAvailableItems={question.options}
                        initialDroppedItems={formData[sectionActual][question.id]}
                        onSortChange={handleQuestionChange}
                        numberOfDropZones={question.options.length}
                        title={question.title}
                        subtitle={question.subtitle}>
                      </SortableList>
                    );
                  })
                }
                {sectionActual === 3 && arrSections[sectionActual].questions.map((question, index) => {
                  return <div key={index} className="test-block-select">
                    <h1>{(question?.correlative || index + 1) + '. ' + question.spanish}</h1>
                    <ul id={question.id}>
                      {question.options.map((option, indexQuestion) => {
                        return <li id={option.id} key={indexQuestion} onClick={selectOption}>
                          <div className={option.selected ? 'select selected' : 'select'}></div>
                          {option.spanish}
                        </li>
                      })}
                    </ul>
                  </div>
                })}
                <div className={`btn-block ${sectionActual === 0 ? 'btn-block-fs' : ''}`}>
                  {AUTOFILL_ENABLED && <button
                    type="button"
                    style={{
                      backgroundColor: '#6c757d',
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      marginRight: 'auto'
                    }}
                    onClick={autoFill}
                  >
                    Fill All (Test)
                  </button>}
                  {sectionActual !== 0 && <button className="btn-back" type="button" disabled={loading} onClickCapture={(e) => {
                    e.stopPropagation();
                    navegacionFormulario('volver');
                  }}>Volver</button>}
                  {sectionActual <= (arrSections.length - 2) && <button type="button" onClickCapture={(e) => {
                    e.stopPropagation();
                    navegacionFormulario('continuar');
                  }}>Continuar</button>}
                  {sectionActual === (arrSections.length - 1) && <button disabled={loading} type="button" onClickCapture={(e) => {
                    e.stopPropagation();
                    submitFormulario();
                  }}>
                    {loading ? 'Enviando...' : 'Continuar a la siguiente sección'}
                  </button>}
                </div>
              </div>
            }
            {
              currentStep === STEPS.FINISHED
              && <Finished
                isBoundedTest={isBoundedTest}
                redirectToCompetencyTest={redirectToCompetencyTest}
                pathToRedirect={pathToRedirect} />
            }
          </div>
          <div className="test-card-footer">
            {
              currentStep === STEPS.TERMS
              && <button onClick={nextQuestionAction} disabled={loading}>{getButtonText()}</button>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

const Finished = ({
  isBoundedTest,
  redirectToCompetencyTest,
  pathToRedirect,
}) => {
  return (
    <div className="finished-test">
      <h2>Test Terminado</h2>
      <img src={emailIcon} alt="icon" />
      <p>¡Has finalizado el test DISC de Growme! Los resultados estarán disponibles en tu correo electrónico muy pronto.</p>
      {
        isBoundedTest && redirectToCompetencyTest
        && <p>Serás redirigido al test de competencias en unos segundos...</p>
      }
      {
        isBoundedTest && redirectToCompetencyTest
        && <p>Redireccionar ahora <a href={pathToRedirect}>aquí</a></p>
      }
    </div>
  );
};

const TestTerms = ({ isBoundedDiscTest }) => {
  return (
    <>
      <div className="gm-instructions">
        {
          isBoundedDiscTest
            ?
            <>
              <p><strong>TE DAMOS LA BIENVENIDA A GROWME</strong></p>
              
              <p>Este test te permitirá conocer mejor tu forma de interactuar, tomar decisiones y desenvolverte en contextos laborales.</p>
              <p>A partir de tus respuestas, obtendrás una mirada sobre tu estilo de comportamiento y sobre algunas tendencias en tu manera de actuar en distintos entornos profesionales.</p>

              <p><strong>¿Cómo funciona?</strong></p>
              <p>El test está compuesto por <strong>dos secciones:</strong></p>

              <p><strong>1. Autopercepción</strong></p>

              <p>En esta parte encontrarás una serie de afirmaciones sobre formas de actuar y relacionarse.</p>
              <p>Selecciona aquellas que mejor representen cómo te describes habitualmente en el entorno laboral.</p>

              <p><strong>2. Situaciones Laborales</strong></p>

              <p>Aquí se presentarán distintos escenarios del mundo del trabajo.</p>
              <p>Tu tarea será indicar cómo actuarías frente a cada situación.</p>

              <p><strong>Antes de comenzar:</strong></p>

              <p>&#10004; No existen respuestas correctas o incorrectas.</p>
              <p>&#10004; Responde de manera honesta y espontánea.</p>
              <p>&#10004; Elige las opciones que mejor reflejen tu comportamiento habitual.</p>

            </>
            :
            <>
              <p><strong>¡Te damos la bienvenida al Test DISC de Growme!</strong></p>
              <p>A través de este test, obtendrás información valiosa sobre cómo te percibes en diferentes ámbitos de tu vida. El Test DISC identifica cuatro tipos de estilos: <strong>Dominante, Influyente, Estable y Analítico</strong>. Esta herramienta te ayudará a comprender en qué medida posees estas características, permitiéndote entender mejor cómo te relacionas con los demás, manejas el estrés, tomas decisiones y actúas en distintas situaciones.</p>
              <p>Al conocer tus fortalezas y áreas de mejora, podrás utilizar esta información para fortalecer tus relaciones personales y profesionales, tomar decisiones más acertadas y trabajar en aspectos que desees desarrollar. Recuerda que este test no tiene un propósito de evaluación o juicio, sino que busca brindarte una perspectiva más clara sobre como te desenvuelves.</p>
              <p>El test está dividido en tres secciones:</p>
              <ol className="gm-instructions-list">
                <li><strong>Cómo te percibes en tus espacios de confort.</strong></li>
                <li><strong>Cómo te percibes en tu entorno laboral.</strong></li>
                <li><strong>Cuáles son tus motivaciones.</strong></li>
              </ol>
              <p>Tómate tu tiempo, reflexiona sobre cada respuesta y disfruta del proceso.</p>
            </>
        }
      </div>
      <p className="gm-is-ready-p">¿Listo (a) para comenzar?</p>
    </>
  );
};

export default DiscTest;
